<template>
  <div>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      bottom
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>
    <div v-for="event in events" :key="event.id" style="margin-bottom: 15px">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>
            {{ event.date | moment("Do MMMM YYYY") }},
            {{ event.room | capitalize }} - {{ event.addressLine1 }} ({{
              event.town
            }})
            <span class="grey--text"
              >({{ event.bookedCount }}/{{ event.slotCount }})</span
            >
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-chip color="grey lighten-1" small>{{ event.code }}</v-chip>
          <v-menu left bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" class="hp--btn">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="csvDownloadAll(events)">
                <v-list-item-title>CSV (All Groups)</v-list-item-title>
              </v-list-item>
              <v-list-item @click="csvDownload(event)">
                <v-list-item-title>CSV (This Group)</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>

        <v-divider></v-divider>
        <v-data-table
          :items="event.slot"
          :headers="slotHeader"
          class="elevation-1"
          :sort-by="['time']"
          :sort-desc="[false]"
          :items-per-page="-1"
        >
          <template v-slot:item.name="{ item }"
            >{{ item.firstname | capitalize }}
            {{ item.lastname | capitalize }}</template
          >
          <template v-slot:item.email="{ item }">
            <b v-if="item.type === 'BREAK' || item.type === 'BLOOD'">
              <v-chip v-if="item.type" color="grey" dark>{{
                item.type
              }}</v-chip>
            </b>
            <span v-else>
              <v-chip v-if="item.email" color="green" dark>Booked</v-chip>
              <v-chip v-if="item.email == ''" color="red" dark
                >Available</v-chip
              >
            </span>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    events: Array,
  },
  data() {
    return {
      createBookingDialog: false,
      createBookingLoader: false,
      slotHeader: [
        { text: "Time", value: "time" },
        { text: "Name", value: "name" },
        { text: "Booked", value: "email" },
      ],
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000,
      },
    };
  },
  methods: {
    csvDownload(download) {
      let bookingTableData = [];
      download.slot.map((event, eventIndex) => {
        if (event.id) {
          bookingTableData.push({
            // id: event.id,
            time: event.time,
            date: moment(download.date).format("DD/MM/YYYY"),
            firstname: event.firstname,
            lastname: event.lastname,
            // email: event.email,
            // mobile: event.mobile,
            // dob: event.dob,
          });
          if (event.customData) {
            let customData = JSON.parse(event.customData);
            if (customData) {
              let key = Object.keys(customData)[0];
              bookingTableData[bookingTableData.length - 1][key] =
                customData[Object.keys(customData)[0]];
            }
          }
        }
      });
      if (bookingTableData.length > 0) {
        bookingTableData = _.orderBy(bookingTableData, "time", "asc");
        this.csvExport(bookingTableData);
      } else {
        this.showSuccessMessage("No CSV results");
      }
    },
    csvDownloadAll(events) {
      let bookingTableData = [];
      events.forEach(function (event, eventIndex) {
        event.slot.forEach(function (slot) {
          if (slot.id) {
            bookingTableData.push({
              // id: slot.id,
              time: slot.time,
              date: moment(event.date).format("DD/MM/YYYY"),
              firstname: slot.firstname,
              lastname: slot.lastname,
              // email: slot.email,
              // mobile: slot.mobile,
              // dob: slot.dob,
            });
            if (slot.customData) {
              let customData = JSON.parse(slot.customData);
              if (customData) {
                let key = Object.keys(customData)[0];
                bookingTableData[bookingTableData.length - 1][key] =
                  customData[Object.keys(customData)[0]];
              }
            }
          }
        });
      });
      if (bookingTableData.length > 0) {
        bookingTableData = _.orderBy(
          bookingTableData,
          ["date", "time"],
          ["asc", "asc"]
        );
        this.csvExport(bookingTableData);
      } else {
        this.showSuccessMessage("No CSV results");
      }
    },
    csvExport(tableData) {
      const arrData = tableData;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map((item) => Object.values(item).join(",")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    },
  },
};
</script>